import { SET } from "@/stores/CommumActionTypes";

const actions = {

	[SET]: ({ commit }, windTurbine) =>
	{
		commit(SET, windTurbine);
	},
};

export default { actions };